// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Video(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Video" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 5H2V19H22V5ZM10 8.99994V14.9999L15 12L10 8.99994Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Video.js.map